import { c as _c } from "react/compiler-runtime";
import { Box, Button, Input, InputGroup, Wrap } from '@chakra-ui/react';
import { CurrencyInput } from '@src/components/sco/CurrencyInput.tsx';
import { DiagnosticColumns } from '@src/components/sco/Funding/FundingLandingDiagnostic/DiagnosticShell';
import { AccentHeading, ChoiceChip, FieldGroup, FieldLabel, Panel, ProofStats, WhyWeAsk } from '@src/components/sco/Funding/FundingLandingDiagnostic/shared';
import { FundingLandingDiagnosticAdditionalFields, INDUSTRY_CHIP_OPTIONS, isIndustryChipActive } from '@src/components/sco/Funding/FundingLandingDiagnostic/types';
import { LocationInput } from '@src/components/sco/LocationInput';
import { useRequestFunnelContext } from '@src/components/sco/RequestFunnel/RequestFunnelContext';
import { ScoTagComboboxInput } from '@src/components/sco/ScoTagComboboxInput';
import tracker from '@src/lib/tracker';
import React, { useEffect, useState } from 'react';
import { LuChevronRight } from 'react-icons/lu';
export const StartupStep: React.FC = () => {
  const $ = _c(82);
  const {
    signupRequest,
    updateSignupRequest,
    setStep,
    saveSignupRequest
  } = useRequestFunnelContext();
  let t0;
  if ($[0] !== signupRequest.additionalFields) {
    t0 = signupRequest.additionalFields || {};
    $[0] = signupRequest.additionalFields;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const additionalFields = t0 as FundingLandingDiagnosticAdditionalFields;
  const hasRaised = additionalFields.hasRaisedFunding;
  let t1;
  if ($[2] !== signupRequest.investorIndustryTagTitles) {
    t1 = signupRequest.investorIndustryTagTitles || [];
    $[2] = signupRequest.investorIndustryTagTitles;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedIndustryTitles = t1;
  const [industryChipKey, setIndustryChipKey] = useState(0);
  const [industryInputReady, setIndustryInputReady] = useState(false);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      tracker.funnelStep(1);
      const frame = requestAnimationFrame(() => setIndustryInputReady(true));
      return () => cancelAnimationFrame(frame);
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== selectedIndustryTitles || $[7] !== updateSignupRequest) {
    t4 = titles => {
      const current = selectedIndustryTitles;
      if (titles.join(";") === current.join(";")) {
        return;
      }
      if (titles.length === 0 && current.length > 0) {
        return;
      }
      updateSignupRequest({
        investorIndustryTagTitles: titles
      });
    };
    $[6] = selectedIndustryTitles;
    $[7] = updateSignupRequest;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleIndustryTagsChange = t4;
  let t5;
  if ($[9] !== updateSignupRequest) {
    t5 = tagTitle => {
      updateSignupRequest({
        investorIndustryTagTitles: [tagTitle]
      });
      setIndustryChipKey(_temp);
    };
    $[9] = updateSignupRequest;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleIndustryChipClick = t5;
  let t6;
  if ($[11] !== saveSignupRequest || $[12] !== setStep || $[13] !== signupRequest.additionalFields || $[14] !== signupRequest.fundingGoalInDollars || $[15] !== signupRequest.investorIndustryTagTitles || $[16] !== signupRequest.location || $[17] !== signupRequest.locationCity || $[18] !== signupRequest.locationCountryKey || $[19] !== signupRequest.locationPostalCode || $[20] !== signupRequest.locationState) {
    t6 = () => saveSignupRequest(() => setStep("traction"), {
      additionalFields: signupRequest.additionalFields,
      fundingGoalInDollars: signupRequest.fundingGoalInDollars,
      investorIndustryTagTitles: signupRequest.investorIndustryTagTitles,
      location: signupRequest.location,
      locationCity: signupRequest.locationCity,
      locationCountryKey: signupRequest.locationCountryKey,
      locationPostalCode: signupRequest.locationPostalCode,
      locationState: signupRequest.locationState
    });
    $[11] = saveSignupRequest;
    $[12] = setStep;
    $[13] = signupRequest.additionalFields;
    $[14] = signupRequest.fundingGoalInDollars;
    $[15] = signupRequest.investorIndustryTagTitles;
    $[16] = signupRequest.location;
    $[17] = signupRequest.locationCity;
    $[18] = signupRequest.locationCountryKey;
    $[19] = signupRequest.locationPostalCode;
    $[20] = signupRequest.locationState;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const persistStartupFields = t6;
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AccentHeading accent="your startup." line1="Tell us about" />;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <>{t7}<WhyWeAsk items={["Raised money outside friends and family?", "Your location helps find nearby investors", "Industry can be broad for now"]} /><ProofStats /></>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FieldLabel>Have you raised capital before?</FieldLabel>;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const t10 = hasRaised === true;
  let t11;
  if ($[25] !== updateSignupRequest) {
    t11 = () => updateSignupRequest({
      additionalFields: {
        hasRaisedFunding: true
      }
    });
    $[25] = updateSignupRequest;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <ChoiceChip active={t10} onClick={t11}>Yes, we have</ChoiceChip>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = hasRaised === false;
  let t14;
  if ($[30] !== updateSignupRequest) {
    t14 = () => updateSignupRequest({
      additionalFields: {
        hasRaisedFunding: false,
        priorFundingAmountLabel: null
      }
    });
    $[30] = updateSignupRequest;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <ChoiceChip active={t13} onClick={t14}>Not yet</ChoiceChip>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t12 || $[36] !== t15) {
    t16 = <FieldGroup>{t9}<Wrap gap={2} justify="flex-start">{t12}{t15}</Wrap></FieldGroup>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== additionalFields.priorFundingAmountLabel || $[39] !== hasRaised || $[40] !== updateSignupRequest) {
    t17 = hasRaised === true && <FieldGroup><FieldLabel>How much have you raised?</FieldLabel><InputGroup startAddon="$" width="full"><Input asChild={true} size="lg"><CurrencyInput placeholder="500,000" textAlign="start" numericValue={additionalFields.priorFundingAmountLabel ? parseInt(additionalFields.priorFundingAmountLabel) : null} onNumericValueChange={value => updateSignupRequest({
            additionalFields: {
              priorFundingAmountLabel: value
            }
          })} /></Input></InputGroup></FieldGroup>;
    $[38] = additionalFields.priorFundingAmountLabel;
    $[39] = hasRaised;
    $[40] = updateSignupRequest;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FieldLabel>Where are you based?</FieldLabel>;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== signupRequest.location || $[44] !== signupRequest.locationCity || $[45] !== signupRequest.locationCountryKey || $[46] !== signupRequest.locationState) {
    t19 = signupRequest.location ? {
      title: signupRequest.location,
      city: signupRequest.locationCity,
      state: signupRequest.locationState,
      countryISO: signupRequest.locationCountryKey
    } : null;
    $[43] = signupRequest.location;
    $[44] = signupRequest.locationCity;
    $[45] = signupRequest.locationCountryKey;
    $[46] = signupRequest.locationState;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== updateSignupRequest) {
    t20 = place => {
      if (!place) {
        return;
      }
      updateSignupRequest({
        location: place.title,
        locationCity: place.city,
        locationState: place.state,
        locationPostalCode: place.postalCode,
        locationCountryKey: place.countryISO,
        locationPlaceId: place.placeId
      });
    };
    $[48] = updateSignupRequest;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t19 || $[51] !== t20) {
    t21 = <FieldGroup>{t18}<Box textAlign="start" width="full"><LocationInput defaultValue={t19} onChange={t20} /></Box></FieldGroup>;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <FieldLabel>What industry best describes you?</FieldLabel>;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== handleIndustryTagsChange || $[55] !== industryChipKey || $[56] !== industryInputReady || $[57] !== selectedIndustryTitles) {
    t23 = industryInputReady && <ScoTagComboboxInput key={`industry-chip-${industryChipKey}`} defaultSelectedTagTitles={selectedIndustryTitles} tagTypeKeys={["investor_industry"]} comboboxTagInputProps={{
      inputProps: {
        tabIndex: 3
      },
      allowMultipleSelections: true
    }} onSelectedTagsChange={tags => handleIndustryTagsChange(tags.map(_temp2))} />;
    $[54] = handleIndustryTagsChange;
    $[55] = industryChipKey;
    $[56] = industryInputReady;
    $[57] = selectedIndustryTitles;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t23) {
    t24 = <Box textAlign="start" width="full">{t23}</Box>;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== handleIndustryChipClick || $[62] !== selectedIndustryTitles) {
    t25 = INDUSTRY_CHIP_OPTIONS.map(chip => <ChoiceChip key={chip.label} active={isIndustryChipActive(chip, selectedIndustryTitles)} onClick={() => handleIndustryChipClick(chip.tagTitle)}>{chip.label}</ChoiceChip>);
    $[61] = handleIndustryChipClick;
    $[62] = selectedIndustryTitles;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t25) {
    t26 = <Wrap gap={2} justify="flex-start" marginTop={1}>{t25}</Wrap>;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t24 || $[67] !== t26) {
    t27 = <FieldGroup>{t22}{t24}{t26}</FieldGroup>;
    $[66] = t24;
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== t16 || $[70] !== t17 || $[71] !== t21 || $[72] !== t27) {
    t28 = <Panel>{t16}{t17}{t21}{t27}</Panel>;
    $[69] = t16;
    $[70] = t17;
    $[71] = t21;
    $[72] = t27;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== persistStartupFields) {
    t29 = () => {
      persistStartupFields();
    };
    $[74] = persistStartupFields;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  let t30;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <LuChevronRight />;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] !== t29) {
    t31 = <Button fontWeight="bold" size="xl" variant="cta" width="full" onClick={t29}>Continue{t30}</Button>;
    $[77] = t29;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t28 || $[80] !== t31) {
    t32 = <DiagnosticColumns left={t8} right={<>{t28}{t31}</>} />;
    $[79] = t28;
    $[80] = t31;
    $[81] = t32;
  } else {
    t32 = $[81];
  }
  return t32;
};
function _temp(key) {
  return key + 1;
}
function _temp2(t) {
  return t.title;
}